import { render, staticRenderFns } from "./ModalLibrary.vue?vue&type=template&id=8ed440f6&"
import script from "./ModalLibrary.vue?vue&type=script&lang=js&"
export * from "./ModalLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports